module.exports = __webpack_public_path__ + "img/ki.ki339d254.svg";